export default "__VITE_ASSET__CuFDMfq8__"